import {Component, OnDestroy, OnInit} from '@angular/core';

import {Subscription} from "rxjs";

import {ActivatedRoute} from "@angular/router";
import {BenutzerDTO} from "../../../models/benutzer/BenutzerDTO";
import {FieldConfigService} from "../../../@core/services/field-config/field-config.service";
import {TranslateService} from "@ngx-translate/core";
import {TextbausteinService} from "../../../@core/services/textbaustein/textbaustein.service";
import {EnumHelperService} from "../../../@core/utils/forms/enum-helper.service";
import {KeyString} from "../../../models/textbaustein/KeyString";
import {ModuleConfigService} from "../../../@core/services/module-config/module-config.service";

@Component({
    selector: 'app-ticket-detail-parent',
    templateUrl: './ticket-detail-parent.component.html',
    styleUrls: ['./ticket-detail-parent.component.scss'],
    standalone: false
})
export class TicketDetailParentComponent implements OnInit, OnDestroy {

  title='';
  subtitle='';

  antragTicketId: string;

  fieldConfig;

  benutzer: BenutzerDTO;
  benutzerRoles: string[];

  subscriptionTranslate: Subscription;

  optionErmaessigung = [];
  optionGeschlecht = [];
  optionWegtyp = [];
  optionSonderfall = [];
  optionSchoolType = [];
  landList = [];

  constructor(
    public translateService: TranslateService,
    private readonly route: ActivatedRoute,
    public textbausteinService: TextbausteinService,
    private readonly fieldConfigService: FieldConfigService,
    private readonly enumHelperService: EnumHelperService,
    private readonly moduleConfigService: ModuleConfigService
  ) {}

  ngOnInit(): void {
        this.setBenutzer();
        this.title = this.textbausteinService.printTextbausteinByKey( KeyString.SUBTITLE_TICKET,
          this.translateService.instant('TICKETDETAIL.TITLE_TICKET'));
        this.loadFieldConfig();
        this.antragTicketId = this.route.snapshot.paramMap.get('id');
        this.initHardcodedLists();
        this.initRequiredFields();
  }

  ngOnDestroy() {
    this.subscriptionTranslate.unsubscribe();
  }

  initRequiredFields(){
   let allFormFields = this.antragTicketFormFields.concat(
      this.antragTicketGeschwister1FormFields, this.antragTicketGeschwister2FormFields,
      this.antragTicketGeschwister3FormFields, this.antragTicketGeschwister4FormFields,
      this.antragTicketGeschwister5FormFields
   );
    if(this.moduleConfigService.isModuleEnabled('antragTicketSepa')){
      allFormFields = allFormFields.concat(this.antragTicketSepaFormFields);
    }
    allFormFields.forEach((varName) => {
      const fieldFromFieldConfig = this.fieldConfigService.getFieldFromFieldConfig(varName, this.fieldConfig);
      if( fieldFromFieldConfig?.visible  || this.alwaysVisible.includes(varName) ){
        this.visibleFields = [...this.visibleFields,varName];
        if(!this.neverValidate.includes(varName) &&
          (this.alwaysValidateIfVisible.includes(varName) ||
            fieldFromFieldConfig?.required)){
          this.requiredFields = [...this.requiredFields,varName];
          if(fieldFromFieldConfig?.required){
            this.fieldConfigValidators = [...this.fieldConfigValidators,varName];
          }
        }
      }
    });
  }

  initHardcodedLists(): void {
    this.subscriptionTranslate = this.translateService.get('dummyTranslation').subscribe(()=>{
      this.optionErmaessigung = [{id: null, name: this.translateService.instant("TICKETDETAIL.ERMAESSIGUNG.KEINE") },
        {id:"ERMAESSIGT", name: this.translateService.instant("TICKETDETAIL.ERMAESSIGUNG.ERMAESSIGT") },
        {id:"ERLASSEN", name: this.translateService.instant("TICKETDETAIL.ERMAESSIGUNG.ERLASSEN") }
      ];
      this.optionGeschlecht = this.enumHelperService.getGeschlechtOptionList();
      this.optionWegtyp = [{id: null, name: "-" },
        {id:"SCHULWEG", name: this.translateService.instant("TICKETDETAIL.WEGTYP.SCHULWEG") },
        {id:"PRAKTIKUMSWEG", name: this.translateService.instant("TICKETDETAIL.WEGTYP.PRAKTIKUMSWEG") },
        {id:"BEIDES", name: this.translateService.instant("TICKETDETAIL.WEGTYP.BEIDES") }
      ];

      // parent creates all
      // child will then filter according to fieldConfig settings and antrag status
      this.optionSonderfall = [
        {value:null, name: this.fieldConfigService.getFieldLabelOrTranslate('NICHT_AUSGEWAEHLT', this.fieldConfig, this.translateService.instant("TICKETDETAIL.SONDERFALL.NICHT_AUSGEWAEHLT"), this.effectiveValidators), info: "" },
        {value:"SCHWERBEHINDERUNG", name: this.fieldConfigService.getFieldLabelOrTranslate('SCHWERBEHINDERUNG', this.fieldConfig, this.translateService.instant('TICKETDETAIL.SONDERFALL.SCHWERBEHINDERUNG'), this.effectiveValidators), info: "" },
        {value:"INKLUSION_BESONDERE_FOERDERUNG", name: this.fieldConfigService.getFieldLabelOrTranslate('INKLUSION_BESONDERE_FOERDERUNG', this.fieldConfig, this.translateService.instant("TICKETDETAIL.SONDERFALL.INKLUSION_BESONDERE_FOERDERUNG"), this.effectiveValidators), info: "" },
        {value:"ERKRANKUNG_VERLETZUNG", name: this.fieldConfigService.getFieldLabelOrTranslate('ERKRANKUNG_VERLETZUNG', this.fieldConfig, this.translateService.instant("TICKETDETAIL.SONDERFALL.ERKRANKUNG_VERLETZUNG"), this.effectiveValidators), info: this.textbausteinService.printTextbausteinByKey(KeyString.SONDERFALL_ERKRANKUNG_VERLETZUNG_INFO, "") },
        {value:"ZUWEISUNG_DES_KOMMUNALEN_INTEGRATIONSZENTRUMS", name: this.fieldConfigService.getFieldLabelOrTranslate('ZUWEISUNG_DES_KOMMUNALEN_INTEGRATIONSZENTRUMS', this.fieldConfig, this.translateService.instant("TICKETDETAIL.SONDERFALL.ZUWEISUNG_DES_KOMMUNALEN_INTEGRATIONSZENTRUMS"), this.effectiveValidators), info: "" },
        {value:"SCHULEMPFEHLUNG_DES_KOMMUNALEN_INTEGRATIONSZENTRUMS", name: this.fieldConfigService.getFieldLabelOrTranslate('SCHULEMPFEHLUNG_DES_KOMMUNALEN_INTEGRATIONSZENTRUMS', this.fieldConfig, this.translateService.instant("TICKETDETAIL.SONDERFALL.SCHULEMPFEHLUNG_DES_KOMMUNALEN_INTEGRATIONSZENTRUMS"), this.effectiveValidators), info: "" },
        {value:"GYMNASIUM_MIT_GEWAEHLTEM_BILINGUALEN_BILDUNGSGANG", name: this.fieldConfigService.getFieldLabelOrTranslate('GYMNASIUM_MIT_GEWAEHLTEM_BILINGUALEN_BILDUNGSGANG', this.fieldConfig, this.translateService.instant("TICKETDETAIL.SONDERFALL.GYMNASIUM_MIT_GEWAEHLTEM_BILINGUALEN_BILDUNGSGANG"), this.effectiveValidators), info: "" },
        {value:"SPORTKLASSE_NRW", name: this.fieldConfigService.getFieldLabelOrTranslate('SPORTKLASSE_NRW', this.fieldConfig, this.translateService.instant("TICKETDETAIL.SONDERFALL.SPORTKLASSE_NRW"), this.effectiveValidators), info: "" },
        {value:"AUSZUBILDENDE_VON_BEZIRKSFACHKLASSEN", name: this.fieldConfigService.getFieldLabelOrTranslate('AUSZUBILDENDE_VON_BEZIRKSFACHKLASSEN', this.fieldConfig, this.translateService.instant("TICKETDETAIL.SONDERFALL.AUSZUBILDENDE_VON_BEZIRKSFACHKLASSEN"), this.effectiveValidators), info: "" },
        {value:"INTERNAT", name: this.fieldConfigService.getFieldLabelOrTranslate('INTERNAT', this.fieldConfig, this.translateService.instant("TICKETDETAIL.SONDERFALL.INTERNAT"), this.effectiveValidators), info: "" },
        {value:"ARBEITSLOSIGKEIT_UND_BERUFSSCHULPFLICHTIGKEIT", name: this.fieldConfigService.getFieldLabelOrTranslate('ARBEITSLOSIGKEIT_UND_BERUFSSCHULPFLICHTIGKEIT', this.fieldConfig, this.translateService.instant("TICKETDETAIL.SONDERFALL.ARBEITSLOSIGKEIT_UND_BERUFSSCHULPFLICHTIGKEIT"), this.effectiveValidators), info: "" },
        {value:"ABLEHNUNG_NAECHSTGELEGENE_SCHULE_DER_SELBEN_SCHULFORM", name: this.fieldConfigService.getFieldLabelOrTranslate('ABLEHNUNG_NAECHSTGELEGENE_SCHULE_DER_SELBEN_SCHULFORM', this.fieldConfig, this.translateService.instant("TICKETDETAIL.SONDERFALL.ABLEHNUNG_NAECHSTGELEGENE_SCHULE_DER_SELBEN_SCHULFORM"), this.effectiveValidators), info: "" },
        {value:"WOHNSITZ_IM_AUSLAND", name: this.fieldConfigService.getFieldLabelOrTranslate('WOHNSITZ_IM_AUSLAND', this.fieldConfig, this.translateService.instant("TICKETDETAIL.SONDERFALL.WOHNSITZ_IM_AUSLAND"), this.effectiveValidators), info: this.translateService.instant("TICKETDETAIL.SONDERFALL.WOHNSITZ_IM_AUSLAND_INFO") },
        {value:"UMZUG_IM_LAUFENDEN_SCHULJAHR", name: this.fieldConfigService.getFieldLabelOrTranslate('UMZUG_IM_LAUFENDEN_SCHULJAHR', this.fieldConfig, this.translateService.instant("TICKETDETAIL.SONDERFALL.UMZUG_IM_LAUFENDEN_SCHULJAHR"), this.effectiveValidators), info: "" },
        {value:"SONSTIGES", name: this.fieldConfigService.getFieldLabelOrTranslate('SONSTIGES', this.fieldConfig, this.translateService.instant("TICKETDETAIL.SONDERFALL.SONSTIGES"), this.effectiveValidators), info: "" },
      ];

      this.optionSchoolType = [{id: null, name: "-" },
        {id:"ELEMENTARY", name: this.translateService.instant("TICKETDETAIL.SCHOOL_TYPE.ELEMENTARY") },
        {id:"GENERAL_SECONDARY", name: this.translateService.instant("TICKETDETAIL.SCHOOL_TYPE.GENERAL_SECONDARY") },
        {id:"INTERMEDIATE_SECONDARY", name: this.translateService.instant("TICKETDETAIL.SCHOOL_TYPE.INTERMEDIATE_SECONDARY") },
        {id:"GRAMMAR", name: this.translateService.instant("TICKETDETAIL.SCHOOL_TYPE.GRAMMAR") },
        {id:"COMPREHENSIVE", name: this.translateService.instant("TICKETDETAIL.SCHOOL_TYPE.COMPREHENSIVE") },
        {id:"VOCATIONAL", name: this.translateService.instant("TICKETDETAIL.SCHOOL_TYPE.VOCATIONAL") },
        {id:"SPECIAL", name: this.translateService.instant("TICKETDETAIL.SCHOOL_TYPE.SPECIAL") },
        {id:"DENOMINATIONAL_ELEMENTARY", name: this.translateService.instant("TICKETDETAIL.SCHOOL_TYPE.DENOMINATIONAL_ELEMENTARY") },
        {id:"CATHOLIC_GENERAL_SECONDARY", name: this.translateService.instant("TICKETDETAIL.SCHOOL_TYPE.CATHOLIC_GENERAL_SECONDARY") },
        {id:"OTHER", name: this.translateService.instant("TICKETDETAIL.SCHOOL_TYPE.OTHER") }
      ];
    });
    this.landList = this.enumHelperService.getLandOptionList();
  }

  setBenutzer(){
    if (sessionStorage.getItem('user')) {
      this.benutzer = JSON.parse(sessionStorage.getItem('user')) as BenutzerDTO;
      this.benutzerRoles = this.benutzer.roles;
    }
  }

  loadFieldConfig(){
    this.fieldConfig = this.fieldConfigService.getFieldConfigFromSessionStorage(['antragTicket', 'antragTicketSepa', 'antragTicketSonderfall']);
    if(!this.fieldConfig||this.fieldConfig.length<1){
      console.log('No fieldConfig found: setting default values');
      this.setFieldConfigDefault();
    }
  }

  //for validation
  visibleFields:            string[] = [];  //all fields set to visible via fieldConfig, static: loaded once on init
  fieldConfigValidators :   string[] = [];  //all fields forced to validate via fieldConfig, static: loaded once on init

  alwaysVisible : string[] = ['schuleId'];
  alwaysValidateIfVisible:  string[] = ['schuleId'];   //if visible = override fieldConfig and force validation, static: loaded once on init


  requiredFields: string[] = []; // fieldConfigValidators MINUS NEVER validate PLUS ALWAYS validate

  neverValidate : string[] = // never validate these fields regardless of config, for example optional checkmarks
    [
      'sonderfallEnabled','bezugAsylbewerberleistungsgesetz','einverstaendnisErklaerung',
      'adresszusatz','adresszusatzSepa','vormundAdresszusatz','praktikumAdresszusatz',
      "referenzFuerZahlungen", 'isAntragstellerNotMandatsgeber', 'schoolType',
      'praktikumHinweis', 'isVormundadresseAbweichend',
      'geschwisterkind1', 'geschwisterkind2','geschwisterkind3','geschwisterkind4','geschwisterkind5'
    ];

  effectiveValidators: string[]  = [];  //the validators that become effective if you try EINREICHEN

  // Felder die optional sichtbar sind, wenn eine der folgenden Optionen gewählt wird:
  //wegtyp
  schulwegOnOff   = [];
  praktikumOnOff  = ['praktikumHinweis','praktikumStelle','praktikumStrasse','praktikumOrt','praktikumPlz','praktikumLand',
    'praktikumStartdatum','praktikumEnddatum','praktikumstageJeWoche','praktikumsvertrag','praktikumAdresszusatz'];
  beidesOnOff     = ['schultageJeWoche'];

  //schultyp
  schuleOnOff = ['schuljahrId','klasseId',];
  berufskollegOnOff = ['schuljahrId','bildungsgangId','bildungsgangdatum','fachbereichId'];
  schuljahrOnOff = ['schuljahrId'];

  //vormund
  vormundOnOff = ['vormundName', 'vormundVorname','vormundGeburtsdatum','vormundTelefonnummer','vormundEmail','vormundGeschlecht', 'isVormundadresseAbweichend'];
  vormundAdresseAbweichendOnOff = ['vormundStrasse','vormundOrt','vormundPlz','vormundLand','vormundAdresszusatz'];



  asylOnOff = ['bezugNachweis'];

  //sepa
  sepaMandatgeberNotAntragst = ['vornameSepa', 'nameSepa', 'strasseSepa', 'plzSepa', 'ortSepa', 'landSepa',
    'emailSepa', 'telefonnummerSepa', 'geburtsdatumSepa', 'geschlechtSepa', 'ibanSepa',
    'bicSepa', 'nameKreditinstitutSepa'];
  sepaMandatgeberYesAntragst = ['iban','bic', 'nameKreditinstitut']

  setFieldConfigDefault() {
    this.fieldConfig = [
      {field: 'name', visible: true, required: true, label: null, module: 'antragTicket'},
      {field: 'vorname', visible: true, required: true, label: null, module: 'antragTicket'},
      {field: 'strasse', visible: true, required: true, label: null, module: 'antragTicket'},
      {field: 'plz', visible: true, required: true, label: null, module: 'antragTicket'},
      {field: 'ort', visible: true, required: true, label: null, module: 'antragTicket'},
      {field: 'geburtsdatum', visible: true, required: true, label: null, module: 'antragTicket'},
      {field: 'email', visible: false, required: true, label: null, module: 'antragTicket'},
      {field: 'emailSchueler', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'telefonnummer', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'land', visible: true, required: true, label: null, module: 'antragTicket'},
      {field: 'einstieghaltestelleId', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'ausstieghaltestelleHinwegId', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'ticketId', visible: true, required: true, label: null, module: 'antragTicket'},
      {field: 'wegtyp', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'schuleId', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'schuljahrId', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'klasseId', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'aboGueltigkeit', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'geschlecht', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'referenzFuerZahlungen', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'abonnementnummerAntrag', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'einverstaendnisErklaerung', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'marketingfreigabe', visible: true, required: true, label: null, module: 'antragTicket'},
      {field: 'geschwisterkind1', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'geschwisterkind2', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'geschwisterkind3', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'geschwisterkind4', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'geschwisterkind5', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'fahrkostenberechtigt', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'umgezogen', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'alteTicketsLiegenBei', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'alteTicketsWerdenZurueckgesandt', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'bildungsgangdatum', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'eigenanteil', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'zuzahlung', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'vormundName', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'vormundVorname', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'vormundStrasse', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'isVormundadresseAbweichend', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'vormundOrt', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'vormundPlz', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'vormundAdresszusatz', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'vormundLand', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'vormundGeburtsdatum', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'vormundTelefonnummer', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'vormundEmail', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'vormundGeschlecht', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'bildungsgangId', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'bildungsgangdatum', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'fachbereichId', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'schultageJeWoche', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'praktikumStelle', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'praktikumHinweis', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'praktikumStrasse', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'praktikumOrt', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'praktikumPlz', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'praktikumLand', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'praktikumAdresszusatz', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'praktikumStartdatum', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'praktikumEnddatum', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'praktikumstageJeWoche', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'sonderfallEnabled', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'sonderfall', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'sonderfallBegruendung', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'bezugAsylbewerberleistungsgesetz', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'adresszusatz', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'zustimmungGesetzlicherVertreter', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'praktikumsvertrag', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'sonderfallNachweis', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'bezugNachweis', visible: true, required: false, label: null, module: 'antragTicket'},
      {field: 'angabenKorrekt', visible: false, required: false, label: null, module: 'antragTicket'},
      {field: 'tarifbestimmungenZugestimmt', visible: false, required: false, label: null, module: 'antragTicket'},
      {field: 'vornameSepa', visible: true, required: false, label: null, module: 'antragTicketSepa'},
      {field: 'nameSepa', visible: true, required: false, label: null, module: 'antragTicketSepa'},
      {field: 'strasseSepa', visible: true, required: false, label: null, module: 'antragTicketSepa'},
      {field: 'plzSepa', visible: true, required: false, label: null, module: 'antragTicketSepa'},
      {field: 'ortSepa', visible: true, required: false, label: null, module: 'antragTicketSepa'},
      {field: 'adresszusatzSepa', visible: true, required: false, label: null, module: 'antragTicketSepa'},
      {field: 'landSepa', visible: true, required: false, label: null, module: 'antragTicketSepa'},
      {field: 'emailSepa', visible: true, required: false, label: null, module: 'antragTicketSepa'},
      {field: 'telefonnummerSepa', visible: true, required: false, label: null, module: 'antragTicketSepa'},
      {field: 'geburtsdatumSepa', visible: true, required: false, label: null, module: 'antragTicketSepa'},
      {field: 'iban', visible: true, required: false, label: null, module: 'antragTicketSepa'},
      {field: 'ibanSepa', visible: true, required: false, label: null, module: 'antragTicketSepa'},
      {field: 'isAntragstellerNotMandatsgeber', visible: true, required: false, label: null,module: 'antragTicketSepa'},
      {field: 'datenschutz', visible: true, required: true, label: null, module: 'antragTicketSepa'},
      {field: 'vertragsbedingungen', visible: false, required: true, label: null, module: 'antragTicketSepa'},
      {field: 'bicSepa', visible: true, required: false, label: null, module: 'antragTicketSepa'},
      {field: 'bic', visible: true, required: false, label: null, module: 'antragTicketSepa'},
      {field: 'nameKreditinstitut', visible: true, required: false, label: null, module: 'antragTicketSepa'},
      {field: 'nameKreditinstitutSepa', visible: true, required: false, label: null, module: 'antragTicketSepa'},
      {field: 'geschlechtSepa', visible: true, required: false, label: null, module: 'antragTicketSepa'},
    ];
  }

  antragTicketFormFields  = [
    // Felder die ohne Umwege direkt von antragTicketDTO in antragTicketForm geladen werden können.

    //persönliche Angaben
    'name','vorname','strasse','plz','ort','geburtsdatum','email','emailSchueler','telefonnummer',
    'schwerbehinderung','aboGueltigkeit','geschlecht','referenzFuerZahlungen','abonnementnummerAntrag',
    'bemerkungAntragsteller','einverstaendnisErklaerung',
    'geschwisterkind1','geschwisterkind2','geschwisterkind3','geschwisterkind4','geschwisterkind5',
    'schuelernummer','richtigkeitDerAngaben','schueler','marketingfreigabe','land', 'adresszusatz',
    'zustimmungGesetzlicherVertreter', 'angabenKorrekt', 'tarifbestimmungenZugestimmt',

    'status',

    //Vormund
    'vormundName', 'vormundVorname', 'isVormundadresseAbweichend', 'vormundStrasse','vormundOrt','vormundPlz','vormundAdresszusatz',
    'vormundLand', 'vormundGeburtsdatum', 'vormundTelefonnummer', 'vormundEmail','vormundGeschlecht',

    //Schule, Praktikum etc.
    'wegtyp', 'bildungsgangId', 'bildungsgangdatum','fachbereichId', 'schultageJeWoche',
    'schuleId','schoolType','schuljahrId','klasseId','ticketId','einstieghaltestelleId','ausstieghaltestelleHinwegId',
    'praktikumStelle', 'praktikumHinweis','praktikumStrasse', 'praktikumOrt', 'praktikumPlz', 'praktikumLand',
    'praktikumAdresszusatz', 'praktikumStartdatum', 'praktikumEnddatum', 'praktikumstageJeWoche', "schoolLevel",

    //Sonderfälle etc.
    'sonderfallEnabled', 'bezugAsylbewerberleistungsgesetz',

    //Nachweise
    'sonderfallNachweis', 'bezugNachweis', 'praktikumsvertrag'


  ];

  antragTicketSepaFormFields = [
    'vornameSepa', 'nameSepa', 'strasseSepa', 'plzSepa', 'ortSepa', 'adresszusatzSepa', 'landSepa',
    'emailSepa', 'telefonnummerSepa', 'geburtsdatumSepa', 'geschlechtSepa', 'iban', 'ibanSepa', 'isAntragstellerNotMandatsgeber',
    'bicSepa', 'bic', 'nameKreditinstitut', 'nameKreditinstitutSepa', 'datenschutz', 'vertragsbedingungen'
  ];

  antragTicketGeschwister1FormFields = [
    'geschwisterkind1name','geschwisterkind1vorname','geschwisterkind1geburtsdatum','geschwisterkind1strasse',
    'geschwisterkind1plz','geschwisterkind1ort','geschwisterkind1schule',
  ];

  antragTicketGeschwister2FormFields = [
    'geschwisterkind2name','geschwisterkind2vorname','geschwisterkind2geburtsdatum','geschwisterkind2strasse',
    'geschwisterkind2plz','geschwisterkind2ort','geschwisterkind2schule',
  ];

  antragTicketGeschwister3FormFields = [
    'geschwisterkind3name','geschwisterkind3vorname','geschwisterkind3geburtsdatum','geschwisterkind3strasse',
    'geschwisterkind3plz','geschwisterkind3ort','geschwisterkind3schule',
  ];

  antragTicketGeschwister4FormFields = [
    'geschwisterkind4name','geschwisterkind4vorname','geschwisterkind4geburtsdatum','geschwisterkind4strasse',
    'geschwisterkind4plz','geschwisterkind4ort','geschwisterkind4schule',
  ];

  antragTicketGeschwister5FormFields = [
    'geschwisterkind5name','geschwisterkind5vorname','geschwisterkind5geburtsdatum','geschwisterkind5strasse',
    'geschwisterkind5plz','geschwisterkind5ort','geschwisterkind5schule',
  ];


}
